import Vue from 'vue'
import { findKey } from 'lodash-es'

export const namespace = 'GNB'

export const types = {
  SEARCH_WORD_AREA_CLASS: 'searchWordAreaClass',
  SET_SEARCH_INPUT_ACTIVATION: 'setSearchInputActivation',
  SET_SEARCH_INPUT_VALUE: 'setSearchInputValue',
  IS_AVAILABLE_RESET_SEARCH_INPUT: 'isAvailableRestSearchInput',
  SET_HOVER_MENU: 'setHoverMenu',
  SET_HOVER_CUSTOM_MENU: 'setHoverCustomMenu',
  SET_HOVER_GNB: 'setHoverGnb',
  IS_MENU_HOVER: 'isMenuHover',
  SET_SHOW_GNB: 'setShowGnb'
}

const state = {
  hover: {
    gnb: false,
    menus: {
      locale: false,
      session: false
    }
  },
  searchInput: {
    value: '',
    active: false
  },
  showGnb: false
}

const getters = {
  [types.SEARCH_WORD_AREA_CLASS]: state => {
    return state.searchInput.active ? 'is_active' : ''
  },
  [types.IS_AVAILABLE_RESET_SEARCH_INPUT]: state => {
    return state.searchInput.active && state.searchInput.value != ''
  },
  [types.IS_MENU_HOVER]: state => {
    return findKey(state.hover.menus, value => value) !== undefined
  }
}

const mutations = {
  [types.SET_SEARCH_INPUT_ACTIVATION](state, payload) {
    state.searchInput.active = payload
  },
  [types.SET_SEARCH_INPUT_VALUE](state, payload) {
    state.searchInput.value = payload
  },
  [types.SET_HOVER_MENU](state, payload) {
    state.hover.gnb = payload.hover
    state.hover.menus[payload.menu] = payload.hover
  },
  [types.SET_HOVER_CUSTOM_MENU](state, payload) {
    Vue.set(state.hover, 'gnb', payload.hover)
    Vue.set(payload.menu, 'hover', payload.hover)
  },
  [types.SET_HOVER_GNB](state, payload) {
    state.hover.gnb = payload
  },
  [types.SET_SHOW_GNB](state, payload) {
    state.showGnb = payload
    if (state.showGnb) {
      document.body.classList.add('is_show_mgnb')
    } else {
      document.body.classList.remove('is_show_mgnb')
    }
  }
}

const actions = {}

export const gnbStore = {
  state,
  mutations,
  getters,
  actions,
  namespace,
  types
}
